import _pick from 'lodash/pick';
import { IUser, IUserMinimize } from 'types/user';

/**
 * Takes in a regular object typed as IUser, and formats it as an IUserMinimized object.
 */
export const getMinimizedUser = (user: IUser): IUserMinimize =>
  _pick(user, ['id', 'firstName', 'lastName', 'avatar', 'email', 'group']);
